import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { useTranslation } from "react-i18next";
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

const ArchivedInstanceConfirmModal = (props) => {
    const { openModal, setOpenModal, archivedInstance, instance } = props;
    const { t } = useTranslation("instances");

    return (
      <Dialog
        open={openModal}
        keepMounted
        onClose={setOpenModal}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle id="lert-dialog-title">
          <GridContainer>
            <GridItem xs={2}>
              <WarningIcon style={styles.icon} />
            </GridItem>
            <GridItem xs={10}>
              <h4>
                {instance && !instance.archived
                  ? t("instances.modal.archived.title")
                  : t("instances.modal.activated.title")}{" "}
                : <span>{instance ? instance.name : ""}</span>
              </h4>
            </GridItem>
          </GridContainer>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {instance && !instance.archived
              ? t("instances.modal.archived.body")
              : t("instances.modal.activated.body")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} color="primary">
            {t("instances.cancel")}
          </Button>
          <Button
            onClick={() => {
              archivedInstance(instance);
              setOpenModal(false);
            }}
            color="primary"
            autoFocus
          >
            {t("instances.save")}
          </Button>
        </DialogActions>
      </Dialog>
    );
}

const styles = {
    icon: {
        fontSize: '40px',
        textAlign: 'center',
        marginLeft: '50%',
        marginRight: '50%',
        marginTop: '10%'
    }
}

export default ArchivedInstanceConfirmModal;
